import { call, put, throttle } from 'redux-saga/effects';
import { errorAllCompanies, loadAllCompanies, loadedAllCompanies } from '../actions/companies';
import GetroClient from '../../api/GetroClient';

export function* allCompaniesEvent({ payload }) {
  try {
    const { network } = payload;
    const response = yield call(GetroClient.getAllCompanies, { networkId: network.id });
    if (!response.error) {
      yield put(loadedAllCompanies(response));
    } else {
      yield put(errorAllCompanies(response.error));
    }
  } catch (error) {
    yield put(errorAllCompanies(error));
  }
}

export default function* networkInformationRequest() {
  yield throttle(1000, loadAllCompanies().type, allCompaniesEvent);
}
